import { render, staticRenderFns } from "./xkw.vue?vue&type=template&id=17ac64a3&"
import script from "./xkw.vue?vue&type=script&lang=js&"
export * from "./xkw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports